import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const DefaultModalOptions: NgbModalOptions = {
  centered: true,
};
